/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Error_Duplicate_Account_YearInputs */

const en_ledger_error_duplicate_account_year = /** @type {(inputs: Ledger_Error_Duplicate_Account_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The query returned the same account twice for one booking year`)
};

const nl_ledger_error_duplicate_account_year = /** @type {(inputs: Ledger_Error_Duplicate_Account_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De query gaf dezelfde rekening twee keer terug voor één boekjaar`)
};

/**
* | output |
* | --- |
* | "The query returned the same account twice for one booking year" |
*
* @param {Ledger_Error_Duplicate_Account_YearInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_error_duplicate_account_year = /** @type {((inputs?: Ledger_Error_Duplicate_Account_YearInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Error_Duplicate_Account_YearInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_error_duplicate_account_year(inputs)
	return en_ledger_error_duplicate_account_year(inputs)
});